<template>
  <svg aria-hidden="true" role="img" viewBox="0 0 24 24">
    <!-- eslint-disable max-len -->
    <path
      fill="currentColor"
      d="m10 17l-3.5-3.5l1.41-1.42L10 14.17L15.18 9l1.41 1.41m2.76-.38A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.03A6.004 6.004 0 0 0 0 14a6 6 0 0 0 6 6h13a5 5 0 0 0 5-5c0-2.64-2.05-4.78-4.65-4.97Z"
    ></path>
    <!-- eslint-enable max-len -->
  </svg>
</template>
